import { useEffect } from 'react';

const useStepController = (values, setStep) => {
  const { eventType, direction } = values;

  useEffect(() => {
    if (direction) {
      setStep(1);
    }
  }, [direction, setStep]);

  useEffect(() => {
    if (eventType) {
      setStep(2);
    }
  }, [eventType, setStep]);
};

export default useStepController;
